<template>
  <div class="recharge-page">
    <!-- 顶部导航 -->
    <header class="header">
      <div class="header-back" @click="goBack">
        <van-icon name="arrow-left" />
      </div>
      <h1 class="header-title">{{ $t('my.recharge_record') }}</h1>
      <div class="header-placeholder"></div>
    </header>

    <!-- 表格标题 -->
    <div class="table-header">
      <div class="col col-time">{{ $t('my.cz_time') || '時間' }}</div>
      <div class="col col-amount">{{ $t('my.cz_money') || '金額' }}</div>
      <div class="col col-status">{{ $t('my.status') || '狀態' }}</div>
    </div>

    <!-- 下拉刷新 -->
    <van-pull-refresh v-model="isLoading" @refresh="getBoostRecords">
      <!-- 空状态 -->
      <div v-if="recordList.length === 0" class="empty-state">
        <van-empty :description="$t('withdraw.empty_data') || '數據為空'" />
      </div>

      <!-- 记录列表 -->
      <div v-else class="record-list">
        <div v-for="(record, index) in recordList" :key="index" class="record-item">
          <div class="col col-time">
            <span class="time-text">{{ record.time }}</span>
          </div>
          <div class="col col-amount">
            <span :class="['status-text', record.money > 0 ? 'positive' : 'negative']">{{ record.amount }} HKD</span>
          </div>
          <div class="col col-status">
            <span class="status-text success">{{ $t('my.success') || '成功' }}</span>
          </div>
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
export default {
  name: 'RechargeList',
  data() {
    return {
      recordList: [],
      isLoading: false
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getBoostRecords() {
      this.isLoading = true;
      this.$http({
        method: 'get',
        url: 'user_get_recharge_list'
      }).then(res => {
        if (res.code === 200) {
          const records = res.data || [];
          this.recordList = records.map(item => {
            let timeStr = item.create_time || item.time || '';
            if (typeof timeStr === 'number') {
              const date = new Date(timeStr * 1000);
              timeStr = date.toLocaleString('zh-CN').replace(/\//g, '-');
            }
            return {
              id: item.id || item.order_id || '',
              time: timeStr,
              amount: item.money || item.amount || '0.00',
              ...item
            };
          });
        } else if (res.code === 401) {
          this.$toast(res.msg);
          this.$router.push({ path: '/Login' });
        }
        this.isLoading = false;
      });
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.getBoostRecords();
    }
  }
};
</script>

<style lang="less" scoped>
.recharge-page {
  min-height: 100vh;
  background: #000;
  color: #f5f5f5;
}

/* 头部 */
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #000;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.header-back {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 28px;
  color: #fff;
}

.header-title {
  flex: 1;
  text-align: center;
  font-size: 28px;
  font-weight: 700;
  margin: 0;
  color: #22cc61;
}

.header-placeholder {
  width: 40px;
}

/* 表格标题 - 3列 */
.table-header {
  display: flex;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.05);
  font-size: 28px;
  font-weight: 600;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.col {
  display: flex;
  align-items: center;
}

.col-time {
  flex: 1.2;
  justify-content: flex-start;
  padding-left: 16px;
}

.col-amount {
  flex: 1;
  justify-content: center;
}

.col-status {
  flex: 0.8;
  justify-content: center;
}

/* 记录列表 */
.record-list {
  padding: 0;
}

.record-item {
  display: flex;
  padding: 16px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  align-items: center;
}

.record-item:last-child {
  border-bottom: none;
}

.time-text {
  font-size: 24px;
  color: #fff;
  line-height: 1.4;
}

.amount-text {
  font-size: 24px;
  color: #fff;
  font-weight: 500;
}

.status-text {
  font-size: 24px;
  font-weight: 500;

  &.success {
    color: #22cc61;
  }

  &.fail {
    color: #ff4444;
  }
}

/* 空状态 */
.empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  padding: 40px 16px;
}
.status-text {
  font-size: 24px;
  font-weight: 500;
	padding:0 20px;
  &.positive {
    color: #fff;
  }

  &.negative {
    color: #ff4444;
  }
}

</style>
